import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { tap } from 'rxjs';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { FileTypeService } from 'src/app/shared/services/file-type.service';
import { ClaimMovieDocumentInfoModel } from '../../models/ClaimMovieDocumentInfo';
import { DocumentInfo } from '../../models/DocumentInfo';
import { UploadDocumentParameters } from '../../models/UploadDocumentParameters';
import { UploadFilesSettings } from '../../models/UploadFilesSettings';
import { DocumentService } from '../../service/document.service';
import { ExportDocumentsService } from '../../service/export-documents.service';
import { ShowDocumentComponent } from '../show-document/show-document.component';

@Component({
  selector: 'app-claim-movies',
  templateUrl: './claim-movies.component.html',
  styleUrls: ['./claim-movies.component.scss']
})
export class ClaimMoviesComponent implements OnInit {
  constructor(
    private documentService: DocumentService,
    private customDialogService: CustomDialogService,
    private fileTypeService: FileTypeService,
    private exportDocumentsService: ExportDocumentsService,
    private translateService: TranslateService
  ) {}

  @Input() documentTypeId: number;
  @Input() claimId: string;
  @Input() isClaimArchived = false;
  @Input() extraReferenceId = '';
  @Input() extraReferenceType = 0;
  @Input() canRemove = true;
  @Input() canUpload = true;

  uploadDocumentParameters: UploadDocumentParameters;
  uploadFilesSettings: UploadFilesSettings;
  claimMovies: ClaimMovieDocumentInfoModel[];

  isLoading = false;
  isError = false;
  colapsed = false;
  checkedAll: boolean;
  selectedAll: boolean;

  moviesRestrictions: FileRestrictions = {
    allowedExtensions: this.fileTypeService.movie_extensions,
    maxFileSize: 200971520,
  };
  
  moviesIdsToRemove = [];


  @ViewChild("claimMoviesDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;

  ngOnInit() {
    this.uploadDocumentParameters = {
      documentTypeId: this.documentTypeId,
      referenceType: ReferenceType.Claim,
      referenceId: this.claimId,
      extraReferenceId: this.extraReferenceId,
      extraReferenceType: this.extraReferenceType,
      otherDocumentKindName : '',
      description: '',
      proofDocumentIds: []
    };

    this.uploadFilesSettings = {
      uploadDocumentParameters : this. uploadDocumentParameters,
      fileRestrictions: this.moviesRestrictions,
      showDocumentDataDialog: false,
      showTopButtons:false,
      autoUpload : false,
      documentDataDialogContent: null
    };

    this.getClaimMovies();
  }

  getClaimMovies() {
    this.isLoading = true;
    this.documentService
      .getClaimMovies(this.claimId, this.documentTypeId, this.extraReferenceType, this.extraReferenceId)
      .pipe(tap(() =>  this.isLoading = false))
      .subscribe({
        next:(res) => {
        this.claimMovies = res;
      },
      error: () => {  this.isLoading = false; this.isError = true;}
    });
  }

  // getThumb(file: ClaimPhotoDocumentInfo) {
  //   return "data:image/jpeg;base64," + file.thumb;
  // }

  removeMovies(): void {
    this.claimMovies = this.claimMovies.filter((x) => !x.isSelected);
  }

  showContent(documentInfo: DocumentInfo) {

    const dialogSettings: CustomDialogSettings = {
      content: ShowDocumentComponent,
      title: `${this.translateService.instant('claims-center.claimDocumentation.movieFile')}  (${documentInfo.name})`,
      minHeight: "60vh",
      minWidth: "60vw",
      maxHeight: "98vh",
      maxWidth: "98vw",
      appendTo:this.containerRef,
      dialogInputs: {
        documentInfo: documentInfo
      }
    };

    this.customDialogService.showDialog(dialogSettings);

  }

  toogle() {
    this.colapsed = !this.colapsed;
  }

  toogleAllToExport() {
    this.checkedAll = !this.checkedAll;
    const ids = this.claimMovies.map((x) => x.id);
    if (this.checkedAll) {
      this.exportDocumentsService.addDocuments(ids);
    } else {
      this.exportDocumentsService.removeDocuments(ids);
    }
  }

  onCheckboxChange(e, documentInfoId: string) {
    this.claimMovies.find((x) => x.id == documentInfoId).isSelected =
      e.target.checked;
  }

  onButtonDelete(): void {

    if(!this.claimMovies.filter((photo) => photo.isSelected)?.length){
      return;
    }

    this.customDialogService.actionWithConfirmation('claims-center.claimDocumentation.doYouReallyWantToDeleteSelectedElements',
    () => {
      this.documentService
      .removeBatchClaimPhoto(
        this.claimMovies
          .filter((movie) => movie.isSelected)
          .map((movie) => movie.id)
      )
      .subscribe(() => this.removeMovies());
        },
        this.containerRef);
  }

  

  onSelectAll(): void {
    this.selectedAll = !this.selectedAll;
    this.claimMovies.forEach((photo) => (photo.isSelected = this.selectedAll));
  }

  /* UPLOAD INTEGRATION */
  newUploadedItem(ev: any) {
    //change to get only single photo to add
    this.getClaimMovies();
  }
  /**/
}
